export default {
    announcements: 'ニュースレター',
    announcementsDescription:
        '月に1、2回ほど新機能などの最新情報を送付します。',
    editNotificationSettings: '通知設定を編集',
    iMy: '自分が.. / 自分の..',
    manageEmails: 'メールアドレスを管理',
    myTeam: '他のメンバーが.. / 他のメンバーの..',
    onboarding: 'ご利用ガイド',
    onboardingDescription:
        'ご利用状況に応じて、MakeLeapsの活用方法などを紹介します。',
    subtitleAccountActivityNotifications: 'アカウント関連の通知',
    subtitleProductNotifications: '製品関連の通知',
    systemNotifications: 'システム通知',
    systemNotificationsDescription:
        'パスワードのリセットなどの重要な通知が送信されます。',
    title: '通知設定',
    userNotifications: 'ユーザー関連の通知',
};
